import { IStore } from "services/indexdb/interface/istore"
import { RdsIdUnique } from "./indexes"

export const SourceStore: IStore = {
    Name: 'Source',
    PrimaryField: 'sourceId',
    Indexes: [RdsIdUnique],
    minimumVersion: 0
}
